import { createParser } from 'nuqs';
import { CalendarDate, formatPlainDate, parsePlainDate } from 'src/features/timezone/utils/datetime';

export const parseAsCalendarDate = createParser<CalendarDate>({
  parse: (value) => parsePlainDate(value),
  serialize: (value) => formatPlainDate(value),
  eq: (a, b) => a.equals(b)
});
